import React from 'react'
import { Container } from 'react-bootstrap'
import Shimmer from './Shimmer'
import { FaImage } from "react-icons/fa"
import "./ProjectCarousel.scss"
function ProjectCarousel() {
  return (
    <Container className="SkeleCon" >
    <div className='ProjectSkeleton_Container'>
        <div className="ProjectSkeleton_wrapper">
            <div className="ProjectSkeleton_Img"> 
                <div className="texting">
                    <div className="ProjectSkeleton_case"></div>
                    <div className="ProjectSkeleton_title"></div>
                    <div className="ProjectSkeletonShortText"></div>
                    <div className="ProjectSkeletonLongText"></div>
                    <div className="ProjectSkeletonLongMedium"></div>
                    <div className="ProjectSkeletonShortText"></div>
                    <div className="ProjectSkeletonLongText"></div>
                    <div className="ProjectSkeletonLongMedium"></div>
                    <div className="ProjectSkeleton_case"></div>
                    <div className="ProjectSkeletonSmallImg">
                        <div className="imgSmall"><FaImage /></div>
                        <div className="imgSmall"><FaImage /></div>
                        <div className="imgSmall"><FaImage /></div>
                        <div className="imgSmall"><FaImage /></div>
                        <div className="imgSmall"><FaImage /></div>
                    </div>
                </div>
                <div className="imgCov">
                <FaImage />
                </div>
                
            </div>
        </div>

        <Shimmer />
    </div>
</Container>
  )
}

export default ProjectCarousel
